/** @format */

import React, { useEffect, useRef, useState } from "react";
import { Button } from "@mantine/core";
import flat from "flat";
import { BeatLoader } from "react-spinners";
import { loadingStates, validateEmail } from "../../utilities/utilities";
import { showNotification } from "@mantine/notifications";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { getPartiesList } from "../../utilities/apis/parties";
import AgreementParty, { KYC_FILE_FIELDS, hasUpload } from "./AgreementParty";
import userPartyCreateHook from "../../hooks/usePartyCreate";
import { getAgreementDetails } from "../../utilities/apis/agreements";
import {
  getBuDetails,
  getOrgDetailsFromMaster,
} from "../../utilities/apis/users";
import { getParentFiles } from "../../utilities/apis/commonApis";
import useMultiFileUpload from "../../hooks/useMultiFileUpload";

const FILE_FIELDS = [
  "uploadGST",
  "uploadPAN",
  "uploadAadhaar",
  "uploadOtherKYCDocument",
];

const AgreementForm3 = ({
  flowData,
  setFlowData,
  id,
  form,
  setUiConfigs,
  uiConfigs,
  save,
  initialState,
}) => {
  const agreementFormJson = flat.unflatten(form.values);
  const [dropDownNames, setDropDownNames] = useState([]);
  const [dataRole, setDataRole] = useState(flowData || {});
  const [parties, setParties] = useState([]);
  const [loader, setLoader] = useState(false);
  const [addParty, setAddParty] = useState(2);
  const kycHydratedRef = useRef(false);
  const array = [
    "firstParty",
    "secondParty",
    "thirdParty",
    "fourthParty",
    "fifthParty",
    "sixthParty",
    "seventhParty",
    "eighthParty",
    "ninthParty",
    "tenthParty",
    "eleventhParty",
    "twelthParty",
    "thirteenthParty",
    "fourteenthParty",
    "fifteenthParty",
    "sixteenthParty",
    "seventeenthParty",
    "eighteenthParty",
    "nineteenthParty",
    "twentythParty",
  ];

  // userPartyCreateHook("firstParty", form, parties, initialState);
  userPartyCreateHook("secondParty", form, parties, initialState);
  userPartyCreateHook("thirdParty", form, parties, initialState);
  userPartyCreateHook("fourthParty", form, parties, initialState);
  userPartyCreateHook("fifthParty", form, parties, initialState);
  userPartyCreateHook("sixthParty", form, parties, initialState);
  userPartyCreateHook("seventhParty", form, parties, initialState);
  userPartyCreateHook("eighthParty", form, parties, initialState);
  userPartyCreateHook("ninthParty", form, parties, initialState);
  userPartyCreateHook("tenthParty", form, parties, initialState);
  userPartyCreateHook("eleventhParty", form, parties, initialState);
  userPartyCreateHook("twelthParty", form, parties, initialState);
  userPartyCreateHook("thirteenthParty", form, parties, initialState);
  userPartyCreateHook("fourteenthParty", form, parties, initialState);
  userPartyCreateHook("fifteenthParty", form, parties, initialState);
  userPartyCreateHook("sixteenthParty", form, parties, initialState);
  userPartyCreateHook("seventeenthParty", form, parties, initialState);
  userPartyCreateHook("eighteenthParty", form, parties, initialState);
  userPartyCreateHook("nineteenthParty", form, parties, initialState);
  userPartyCreateHook("twentythParty", form, parties, initialState);

  const { addFiles, finalFiles } = useMultiFileUpload({
    loadFromParent: false,
    parent: "agreement",
    parentId: id,
  });

  const partiesApi = async (name) => {
    const { data: res } = await apiWrapWithErrorWithData(
      getPartiesList({ name }),
    );
    setParties(res);
    const names = res.map(({ name: val }) => val);

    setDropDownNames(names);
  };

  useEffect(() => {
    for (let i = 20; i >= 1; i--) {
      const partyName = array[i - 1];
      if (
        agreementFormJson[partyName] &&
        Object.keys(agreementFormJson[partyName]).length
      ) {
        setAddParty(i);
        break;
      }
    }
    partiesApi();
  }, []);
  //
  const validate = () => {
    const keys = {};

    const validateParty = (party) => {
      if (!party?.data) return;
      const { data, name } = party;
      const isEntity = data.type === "Entity";
      const isIndividual = data.type === "Individual";

      // ── First party: signing authority ──────────────────────────────────────
      if (name === "firstParty") {
        if (
          !dataRole["7"] ||
          dataRole["7"].length === 0 ||
          !dataRole["7"][0]?.userId
        ) {
          keys[`firstParty.signingAuthority`] =
            "Please select signing authority.";
          keys[`firstParty.signingAuthority`] =
            "Please select signing authority.";
        }
        return;
      }

      // ── Entity type ─────────────────────────────────────────────────────────
      if (isEntity) {
        if (!data.name?.trim())
          keys[`${name}.name`] = "Please enter legal name.";
        else if (data.name.trim().length < 3)
          keys[`${name}.name`] = "Legal name must be at least 3 characters.";

        if (!data.entityType)
          keys[`${name}.entityType`] = "Please select entity type.";

        if (!data.partyType)
          keys[`${name}.partyType`] = "Please select party type.";

        if (!data.partyCode?.trim())
          keys[`${name}.partyCode`] = "Please enter party code.";

        if (!data.brandName?.trim())
          keys[`${name}.brandName`] = "Please enter brand name.";
        else if (data.brandName.trim().length < 2)
          keys[`${name}.brandName`] =
            "Brand name must be at least 2 characters.";

        if (!data.signatory?.trim())
          keys[`${name}.signatory`] = "Please enter authorised signatory name.";
        else if (data.signatory.trim().length < 2)
          keys[`${name}.signatory`] =
            "Signatory name must be at least 2 characters.";

        if (!data.email?.trim())
          keys[`${name}.email`] = "Please enter authorised signatory email.";
        else if (!validateEmail(data.email))
          keys[`${name}.email`] = "Please enter a valid email address.";

        if (!data.address?.trim())
          keys[`${name}.address`] = "Please enter registered address.";
        else if (data.address.trim().length < 5)
          keys[`${name}.address`] =
            "Registered address must be at least 5 characters.";

        if (!data.corporateAddress?.trim())
          keys[`${name}.corporateAddress`] = "Please enter corporate address.";
        else if (data.corporateAddress.trim().length < 5)
          keys[`${name}.corporateAddress`] =
            "Corporate address must be at least 5 characters.";

        if (!data.representative?.trim())
          keys[`${name}.representative`] = "Please enter business POC name.";
        else if (data.representative.trim().length < 2)
          keys[`${name}.representative`] =
            "POC name must be at least 2 characters.";

        if (!data.pocemail?.trim())
          keys[`${name}.pocemail`] = "Please enter business POC email.";
        else if (!validateEmail(data.pocemail))
          keys[`${name}.pocemail`] = "Please enter a valid email address.";

        if (!data.pocphone?.trim())
          keys[`${name}.pocphone`] = "Please enter business POC phone.";
        else if (!/^\d{10}$/.test(data.pocphone))
          keys[`${name}.pocphone`] = "Phone must be exactly 10 digits.";

        if (!data.gstNo?.trim()) keys[`${name}.gstNo`] = "Please enter GSTIN.";
        else if (!/^[A-Z0-9]{15}$/.test(data.gstNo.toUpperCase()))
          keys[`${name}.gstNo`] =
            "GSTIN must be exactly 15 alphanumeric characters.";

        if (!data.panNo?.trim()) keys[`${name}.panNo`] = "Please enter PAN.";
        else if (!/^[A-Z0-9]{10}$/.test(data.panNo.toUpperCase()))
          keys[`${name}.panNo`] =
            "PAN must be exactly 10 alphanumeric characters.";

        if (!hasUpload(data.uploadGST))
          keys[`${name}.uploadGST`] = "Please upload GST certificate.";

        if (!hasUpload(data.uploadPAN))
          keys[`${name}.uploadPAN`] = "Please upload PAN card.";
      }

      // ── Individual type ─────────────────────────────────────────────────────
      if (isIndividual) {
        if (!data.indi_name?.trim())
          keys[`${name}.indi_name`] = "Please enter individual name.";
        else if (data.indi_name.trim().length < 3)
          keys[`${name}.indi_name`] = "Name must be at least 3 characters.";

        if (!data.indi_fatherName?.trim())
          keys[`${name}.indi_fatherName`] = "Please enter father's name.";
        else if (data.indi_fatherName.trim().length < 2)
          keys[`${name}.indi_fatherName`] =
            "Father's name must be at least 2 characters.";
        keys[`${name}.indi_fatherName`] =
          "Father's name must be at least 2 characters.";

        if (!data.indi_address?.trim())
          keys[`${name}.indi_address`] = "Please enter residence address.";
        else if (data.indi_address.trim().length < 5)
          keys[`${name}.indi_address`] =
            "Residence address must be at least 5 characters.";
        keys[`${name}.indi_address`] =
          "Residence address must be at least 5 characters.";

        if (!data.indi_email?.trim())
          keys[`${name}.indi_email`] = "Please enter email.";
        else if (!validateEmail(data.indi_email))
          keys[`${name}.indi_email`] = "Please enter a valid email address.";

        if (!data.indi_pan?.trim())
          keys[`${name}.indi_pan`] = "Please enter PAN.";
        else if (!/^[A-Z0-9]{10}$/.test(data.indi_pan.toUpperCase()))
          keys[`${name}.indi_pan`] =
            "PAN must be exactly 10 alphanumeric characters.";
        keys[`${name}.indi_pan`] =
          "PAN must be exactly 10 alphanumeric characters.";

        if (!data.indi_phone?.trim())
          keys[`${name}.indi_phone`] = "Please enter phone number.";
        else if (!/^\d{10}$/.test(data.indi_phone))
          keys[`${name}.indi_phone`] = "Phone must be exactly 10 digits.";

        if (!data.aadhaarNo?.trim())
          keys[`${name}.aadhaarNo`] = "Please enter Aadhaar number.";
        else if (!/^\d{12}$/.test(data.aadhaarNo))
          keys[`${name}.aadhaarNo`] = "Aadhaar must be exactly 12 digits.";

        if (!data.gstNo?.trim()) keys[`${name}.gstNo`] = "Please enter GSTIN.";
        if (!data.gstNo?.trim()) keys[`${name}.gstNo`] = "Please enter GSTIN.";
        else if (!/^[A-Z0-9]{15}$/.test(data.gstNo.toUpperCase()))
          keys[`${name}.gstNo`] =
            "GSTIN must be exactly 15 alphanumeric characters.";
        keys[`${name}.gstNo`] =
          "GSTIN must be exactly 15 alphanumeric characters.";

        if (!hasUpload(data.uploadPAN))
          if (!hasUpload(data.uploadPAN))
            keys[`${name}.uploadPAN`] = "Please upload PAN card.";

        if (!hasUpload(data.uploadAadhaar))
          if (!hasUpload(data.uploadAadhaar))
            keys[`${name}.uploadAadhaar`] = "Please upload Aadhaar card.";

        if (!hasUpload(data.uploadGST))
          if (!hasUpload(data.uploadGST))
            keys[`${name}.uploadGST`] = "Please upload GST certificate.";
      }
    };

    // ── Duplicate file name check across all parties ─────────────────────────
    const FILE_FIELDS = KYC_FILE_FIELDS;
    const fileEntries = [];

    array.forEach((partyKey) => {
      const partyData = agreementFormJson[partyKey];
      if (!partyData || typeof partyData !== "object") return;
      FILE_FIELDS.forEach((field) => {
        const value = partyData[field];
        const fileName =
          value instanceof File
            ? value.name
            : value?.name || (typeof value === "string" ? value : null);
        if (fileName) {
          fileEntries.push({
            formKey: `${partyKey}.${field}`,
            name: fileName.toLowerCase(),
          });
        }
      });
    });

    const nameCounts = fileEntries.reduce((acc, { name }) => {
      acc[name] = (acc[name] || 0) + 1;
      return acc;
    }, {});

    fileEntries.forEach(({ formKey, name }) => {
      if (nameCounts[name] > 1) {
        keys[formKey] =
          `Duplicate file name "${name}". Each uploaded file must have a unique name.`;
        keys[formKey] =
          `Duplicate file name "${name}". Each uploaded file must have a unique name.`;
      }
    });

    // let parties = [agreementFormJson.firstParty, agreementFormJson.secondParty];
    const parties = [
      { data: agreementFormJson.firstParty, name: "firstParty" },
      { data: agreementFormJson.secondParty, name: "secondParty" },
    ];

    for (let i = 3; i <= Math.min(addParty, 20); i++) {
      const partyName = array[i - 1]; // Get the corresponding party name from the array
      parties.push({
        data: agreementFormJson[partyName],
        name: `${partyName}`,
      });
    }
    // parties =  [...new Set(parties)];
    parties.forEach((party, index) => validateParty(party, index));

    if (Object.keys(keys).length !== 0) {
      form.setErrors(keys);
      showNotification({
        color: "red",
        title: "Agreement Form",
        message: "Please check all fields are filled properly.",
      });
    }

    return Object.keys(keys).length === 0;
  };
  useEffect(() => {
    const fetchData = async () => {
      const agreementId = id;
      const data = await apiWrapWithErrorWithData(
        getAgreementDetails({ agreementId }),
      );
      const fetchedDataRole = data.agreement?.flowJson;
      if (fetchedDataRole) {
        setDataRole(fetchedDataRole);
      }

      const filesResp = await apiWrapWithErrorWithData(
        getParentFiles({ parent: "agreement", parentId: id }),
      );
      filesResp?.files?.forEach((f) => {
        if (f.field) {
          form.setFieldValue(f.field, {
            name: f.fileName,
            fileId: f.id,
            hostedLink: f.hostedLink,
            field: f.field,
          });
        }
      });
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!id || kycHydratedRef.current) return;

    const hasPartyFiles = array.some((partyKey) => {
      const party = agreementFormJson[partyKey];
      if (!party) return false;
      return KYC_FILE_FIELDS.some((field) => hasUpload(party[field]));
    });
    if (!hasPartyFiles && !form.values.formCompleted) return;

    kycHydratedRef.current = true;
    let cancelled = false;

    (async () => {
      const resp = await apiWrapWithErrorWithData(
        getParentFiles({ parent: "agreement", parentId: id }),
      );
      if (cancelled) return;

      const parentFiles = resp?.success ? resp.files || [] : [];

      form.setValues((prev) => {
        const next = { ...prev };
        const unflat = flat.unflatten(prev);

        array.forEach((partyKey) => {
          if (partyKey === "firstParty") return;
          KYC_FILE_FIELDS.forEach((field) => {
            const current = unflat[partyKey]?.[field];
            if (current instanceof File) return;

            const storedName =
              current?.name || prev[`${partyKey}.${field}.name`];
            if (!storedName) return;

            const match = parentFiles.find(
              (f) =>
                (f.fileName || f.name || "").toLowerCase() ===
                storedName.toLowerCase(),
            );

            const fieldPath = `${partyKey}.${field}`;
            delete next[`${fieldPath}.name`];
            delete next[`${fieldPath}.fileId`];
            delete next[`${fieldPath}.hostedLink`];
            delete next[`${fieldPath}.field`];
            delete next[`${fieldPath}.url`];

            next[fieldPath] = {
              name: storedName,
              field,
              ...(match
                ? {
                    fileId: match.id || match.fileId,
                    hostedLink: match.hostedLink || match.url,
                  }
                : {
                    ...(current?.fileId ? { fileId: current.fileId } : {}),
                    ...(current?.hostedLink
                      ? { hostedLink: current.hostedLink }
                      : {}),
                  }),
            };
          });
        });

        return next;
      });
    })();

    return () => {
      cancelled = true;
    };
  }, [id, form.values.formCompleted, agreementFormJson]);
  const savePrev = async () => {
    setUiConfigs({
      ...uiConfigs,
      currentStep: 1,
    });
  };
  const saveNext = async () => {
    if (validate()) {
      const data = flat.unflatten(form.values);
      const docs = [];

      array.forEach((party) => {
        const partyData = data?.[party];
        if (
          !partyData ||
          typeof partyData !== "object" ||
          Object.keys(partyData).length === 0
        ) {
          return;
        }

        const fileFields = KYC_FILE_FIELDS;

        fileFields.forEach((field) => {
          const file = partyData[field];
          const fieldKey = `${party}.${field}`;

          if (file instanceof File) {
            docs.push(file);
            partyData[field] = { name: file.name, field };
          } else if (hasUpload(file)) {
            partyData[field] = {
              name: file.name,
              field: file.field || field,
              ...(file.fileId ? { fileId: file.fileId } : {}),
              ...(file.hostedLink ? { hostedLink: file.hostedLink } : {}),
            };
          }
        });
      });
      setLoader(true);
      const res = docs.length === 0 ? "fulfilled" : await addFiles(docs);
      if (res === "fulfilled") {
        setFlowData(dataRole);
        await save({ ...flat(data), formCompleted: true });
        setUiConfigs({
          ...uiConfigs,
          currentStep: 3,
        });
      } else {
        showNotification({
          color: "red",
          title: "Uploading Documents",
          message: "Unable to upload documents! Please try again.",
        });
      }
      setLoader(false);
    }
  };

  const handlePartySelect = (partyKey, selectedName) => {
    const selectedPartyData = parties.find((p) => p.name === selectedName);

    form.setValues((prevValues) => {
      const unflattened = flat.unflatten(prevValues);
      const currentParty = unflattened[partyKey] || {};

      if (selectedPartyData) {
        return flat({
          ...initialState,
          ...unflattened,
          [partyKey]: {
            ...currentParty,
            name: selectedName,
            type: selectedPartyData.type || "Entity",
            entityType:
              selectedPartyData.companyType ||
              selectedPartyData.entityType ||
              "Company",
            brandName: selectedPartyData.brandName || "",
            email: selectedPartyData.email || "",
            pocemail: selectedPartyData.pocemail || "",
            signatory: selectedPartyData.signatory || "",
            representative: selectedPartyData.representative || "",
            address:
              selectedPartyData.registeredOfficeAddress ||
              selectedPartyData.residenceOf ||
              currentParty.address ||
              "",
            corporateAddress:
              selectedPartyData.corporateOfficeAddress ||
              currentParty.corporateAddress ||
              "",
          },
        });
      }

      return flat({
        ...initialState,
        ...unflattened,
        [partyKey]: {
          ...currentParty,
          type: currentParty.type || "Entity",
          name: selectedName,
        },
      });
    });
  };

  return (
    <div className="w-full flex flex-col">
      <div className="flex flex-col justify-between">
        {array.slice(0, addParty).map((partyName, index) => (
          <AgreementParty
            key={partyName}
            agreementFormJson={agreementFormJson}
            dropDownNames={dropDownNames}
            form={form}
            partyName={partyName}
            setDropDownNames={setDropDownNames}
            onPartySelect={
              partyName === "firstParty" ? undefined : handlePartySelect
            }
            dataRole={dataRole}
            setDataRole={setDataRole}
            id={id}
            setAddParty={setAddParty}
            addParty={addParty}
          />
        ))}
      </div>
      <div className={`flex justify-end items-center mt-4`}>
        {addParty < 20 && (
          <Button
            style={{
              backgroundColor: "#46BDE1",
            }}
            onClick={() => setAddParty((pre) => pre + 1)}
          >
            Add Party
          </Button>
        )}
      </div>
      <div className="flex items-center justify-between mt-20">
        <Button
          className="max-w-xs "
          onClick={savePrev}
          style={{
            backgroundColor: "#46BDE1",
          }}
          disabled={uiConfigs.loading === loadingStates.LOADING}
        >
          Previous
        </Button>
        <Button
          className="max-w-xs"
          style={{
            backgroundColor: "#46BDE1",
          }}
          onClick={saveNext}
          disabled={uiConfigs.loading === loadingStates.LOADING || loader}
        >
          {uiConfigs.loading === loadingStates.LOADING || loader ? (
            <BeatLoader color={"#fff"} size={10} />
          ) : (
            "Save & Next"
          )}
        </Button>
      </div>
    </div>
  );
};

export default AgreementForm3;
